import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getCurrentUserInfo,
  recordPulseHeartbeat,
} from "@/services/api/user";
import {
  installPulseEngagementListeners,
  PULSE_HEARTBEAT_MS,
} from "@/utils/pulseTelemetry";

export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    installPulseEngagementListeners();
  }, []);

  useEffect(() => {
    getCurrentUserInfo(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const sendHeartbeat = () => {
      if (document.visibilityState !== "visible") return;
      recordPulseHeartbeat(location.pathname).catch(() => {});
    };

    sendHeartbeat();
    const intervalId = window.setInterval(sendHeartbeat, PULSE_HEARTBEAT_MS);
    return () => window.clearInterval(intervalId);
  }, [location.pathname]);

  return null;
};
